const DP_LOGO =
  "https://customer-assets.emergentagent.com/job_alpha-motion-gallery/artifacts/3n8ubrc6_Transparent%20White%20Lettering-MCBFPP%20%281%29.png";

const DPLogo = () => (
  <div
    data-testid="dp-logo-reactor"
    className="absolute left-[4%] top-1/2 -translate-y-1/2 z-[3] pointer-events-none hidden 2xl:flex items-center justify-center"
  >
    <div className="relative w-[200px] h-[200px] flex items-center justify-center">
      {/* Ring 1 - Outer dashed */}
      <div className="absolute inset-0 rounded-full border border-dashed border-cyan-500/15 animate-spin-slow" style={{ willChange: "transform" }} />

      {/* Ring 2 - Partial reverse */}
      <div
        className="absolute inset-[12%] rounded-full animate-spin-reverse-slow"
        style={{
          borderTop: "1px solid rgba(6,182,212,0.3)",
          borderRight: "1px solid transparent",
          borderBottom: "1px solid transparent",
          borderLeft: "1px solid rgba(6,182,212,0.15)",
          borderRadius: "9999px",
          willChange: "transform",
        }}
      />

      {/* Logo */}
      <div data-testid="dp-logo-image" className="absolute inset-[30%] rounded-full overflow-hidden flex items-center justify-center">
        <img
          src={DP_LOGO}
          alt="D|P"
          className="w-full h-full object-contain p-2"
          style={{
            mixBlendMode: "lighten",
            filter: "brightness(0.6) sepia(1) saturate(3) hue-rotate(140deg)",
            opacity: 0.7,
          }}
        />
      </div>
    </div>
  </div>
);

export default DPLogo;
